// Firebase configuration file
import { initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDZomRCaERkMLJat35S_Z1764fug8cPI94",
  authDomain: "belkysveterinariaweb.firebaseapp.com",
  projectId: "belkysveterinariaweb",
  storageBucket: "belkysveterinariaweb.appspot.com",
  messagingSenderId: "1090653193157",
  appId: "1:1090653193157:web:39190758a8808b484a41ac",
  measurementId: "G-S4M4R61E8M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Solo exportamos la instancia de la aplicación
// Los servicios específicos (auth, db, storage) deben ser inicializados
// donde se necesiten para evitar problemas de importación circular
export default app;
